import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import CopyButton from '../../CopyButton';

interface Props {
  content: string;
  instructions?: React.ReactNode[];
  onCopy?: () => void | Promise<void>;
}

function StepFlowCopy({ content, instructions, onCopy }: Props) {
  return (
    <Stack gap={2.5} width="100%" boxSizing="border-box">
      <Box
        boxSizing="border-box"
        width="100%"
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        gap={2}
        py="5px"
        px="10px"
        sx={{
          borderRadius: '10px',
          backgroundColor: theme => theme.palette.lightGrey.main,
        }}>
        <Typography variant="body2" noWrap flexShrink={1}>
          {content}
        </Typography>
        <CopyButton content={content} onCopy={onCopy} />
      </Box>
      {!!instructions?.length && (
        <Stack gap={1}>
          {instructions.map((instruction, index) => (
            <Box
              key={typeof instruction === 'string' ? instruction : index}
              display="flex"
              alignItems="start"
              gap={1}>
              <Typography
                key={`${instruction?.toString() || index}-number`}
                variant="body2">
                {index + 1}.
              </Typography>
              {typeof instruction === 'string' ? (
                <Typography
                  key={instruction?.toString() || index}
                  variant="body2">
                  {instruction}
                </Typography>
              ) : (
                instruction
              )}
            </Box>
          ))}
        </Stack>
      )}
    </Stack>
  );
}

export default StepFlowCopy;
